import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=def4f912&scoped=true&"
import script from "./DataCard.vue?vue&type=script&lang=js&"
export * from "./DataCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def4f912",
  null
  
)

export default component.exports